import { render, staticRenderFns } from "./cbord.vue?vue&type=template&id=4a033d42"
import script from "./cbord.vue?vue&type=script&lang=js"
export * from "./cbord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src881454487/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a033d42')) {
      api.createRecord('4a033d42', component.options)
    } else {
      api.reload('4a033d42', component.options)
    }
    module.hot.accept("./cbord.vue?vue&type=template&id=4a033d42", function () {
      api.rerender('4a033d42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cbord.vue"
export default component.exports